import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import { LOCATION_BY_KEY, LOCATION_SEARCHABLE_GET, LOCATIONS_BY_IDS } from "../const/LocationConst";

/**
 * Data Access for the User API
 * @name LocationDao
 * @param props
 * @return {null|*}
 */
const LocationDao = (props) => {
    const { action, key, params, token } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        }
    };
    switch (action) {
        case "locationByKeyRead":
            options.method = "GET";
            options.url = `${LOCATION_BY_KEY}/${key}/detail.json`;
            break;
        case "locationsRead":
            options.method = "GET";
            options.url = LOCATIONS_BY_IDS;
            if (params) {
                options.params = params;
            }
            break;
        case "locationsSearchableRead":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.url = LOCATION_SEARCHABLE_GET;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

LocationDao.propTypes = {
    action: PropTypes.string.isRequired,
    key: PropTypes.string,
    params: PropTypes.objectOf([PropTypes.object]),
    token: PropTypes.string.isRequired
};

LocationDao.defaultProps = {
    key: null,
    params: null
};

export default LocationDao;
